import type { RouteConfig } from 'vue-router';

const PassThrough = () => import('@/views/PassThrough.vue');
const QuotesList = () => import('@/pages/customers/quotes/QuotesList.vue');

const quotesRoutes: RouteConfig[] = [
  {
    path: 'quotes-new/:group?',
    name: 'quotes-new',
    redirect: (to) => ({ path: `/v3/customers/quotes/${to.params.group ?? ''}` }),
  },
  {
    path: 'quote-new/:uuid?',
    name: 'quote-new',
    props: true,
    redirect: (to) => ({ path: `/v3/customers/quotes/quote/${to.params.uuid ?? ''}` }),
  },
  {
    path: 'templates/quotes-new',
    name: 'template-quotes-new',
    redirect: { path: '/v3/customers/templates/quotes' },
  },
  {
    path: 'templates/quote-new/:uuid?',
    name: 'template-quote-new',
    props: true,
    redirect: (to) => ({ path: `/v3/customers/templates/quotes/quote/${to.params.uuid ?? ''}` }),
  },
  {
    path: 'quotes',
    alias: ['quote'],
    component: PassThrough,
    children: [
      {
        path: ':group?',
        name: 'quotes-list',
        meta: {
          title: 'quotes',
        },
        component: QuotesList,
        beforeEnter(to, _, next) {
          if (!to.params.group) {
            next({ name: 'quotes-list', params: { group: 'open' } });
          } else {
            next();
          }
        },
      },
    ],
  },
];

export default quotesRoutes;
